import React from "react";

// Hub and Gateway settings from DS
const DataContext = React.createContext({
  settings: {},
  setSettings: () => {}
});

export default DataContext;